<template>
    <div class="titulo">
        <div class="margem container">
            <h2>{{`${tipos?.find(i => i.id == tipo)?.nome ?? ''}`}}</h2>
        </div>
    </div>
    <div class="margem container" v-if="!loading">
        <div class="bloco margem">
            <fieldset class="grid-3">
                <div><label>Descrição</label>
                    <input type="text" v-model="protocolo.nome" :required="!protocolo.nome">
                </div>
                <div><label>Setor Solicitante</label>
                    <select v-model="protocolo.setor_id" :required="!protocolo.setor_id">
                        <option v-for="item in setores" :key="item.id" :value="item.id"
                            :style="{ 'font-weight': (item.nivel_hierarquico <= 2) ? 'bold' : '0' }">
                            <span v-if="item.nivel_hierarquico === 3" style="color: red;"> &nbsp;&nbsp; </span>
                            {{ item.nivel_hierarquico === 3 ? "-" : '' }} {{ item.nome }}
                        </option>
                    </select>
                </div>
                <div><label>Setor Destinatário</label>
                    <select v-model="protocolo.setorDestinatario_id" :required="!protocolo.setorDestinatario_id">
                        <option v-for="item in setores" :key="item.id" :value="item.id"
                            :style="{ 'font-weight': (item.nivel_hierarquico <= 2) ? 'bold' : '0' }">
                            <span v-if="item.nivel_hierarquico === 3" style="color: red;"> &nbsp;&nbsp; </span>
                            {{ item.nivel_hierarquico === 3 ? "-" : '' }} {{ item.nome }}
                        </option>
                    </select>
                </div>
                <div><label>Responsável</label>
                    <select :required="!protocolo.responsavel_id" v-model="protocolo.responsavel_id"
                        @change="atualizarSetorDestinatarioPorResponsavel">
                        <option v-for="item in gerente" :key="item.id" :value="item.id"> {{ item.nomeCompleto }}
                        </option>
                    </select>
                </div>
                <div><label>Data da Criação</label>
                    <input type="date" v-model="protocolo.dtInicio" :required="!protocolo.dtInicio">
                </div>
                <div><label>Data Prevista de Conclusão</label>
                    <input type="date" v-model="protocolo.dtFimPrevisto" :required="!protocolo.dtFimPrevisto">
                </div>
                <div class="col-3">
                    <label>Observações / Escopo</label>
                    <textarea v-model="protocolo.obs" style="height: 200px"></textarea>
                </div>
            </fieldset>
            <div class="submit direita">
                <button @click="criarProtocolo()" :disabled="camposVazios"
                    :title="camposVazios ? 'Preencha os campos destacados' : ''">Criar</button>
                <button class="acao-secundaria" @click="this.$router.push('/protocolos')">Cancelar</button>
            </div>
        </div>
    </div>
    <div class="loading" v-else>
        <div></div>
    </div>
</template>
<script>
import { dataParaInput } from "@/utils/date";
import { useApiError } from "@/composables/useApiError";
import serviceProtocolo from "@/services/serviceProtocolo";
import { consultarSetores } from "@/services/usuario-setor";
import { sso } from "roboflex-thalamus-sso-lib";
import { api } from "roboflex-thalamus-request-handler";

export default {
    name: "CriarProtocolo",

    setup() {
        const { handleError } = useApiError();
        return { handleApiError: handleError };
    },

    props: {
        tipo: {
            required: true,
        },
    },

    data() {
        return {
            protocolo: { tipo_id: this.tipo },
            setores: null,
            tipos: null,
            gerente: [],
            idUsuario: null,
            loading: false,
        };
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado();
        this.idUsuario = usuarioLogado.id;
        this.protocolo.responsavel_id = usuarioLogado.id;
        this.protocolo.dtInicio = dataParaInput(new Date().toISOString());
    },

    mounted() {
        this.carregarGerentesSetoresETipos();
    },

    computed: {
        camposVazios() {
            const campos = ["nome", "setor_id", "responsavel_id", "dtInicio", "dtFimPrevisto", "setorDestinatario_id"];
            return campos.some((campo) => {
                const valor = this.protocolo?.[campo];
                return valor === null || valor === undefined || valor === "";
            });
        },
    },

    watch: {
        "protocolo.responsavel_id"() {
            this.atualizarSetorDestinatarioPorResponsavel();
        },
    },

    methods: {
        /**
         * Define o setor destinatário com base no responsável selecionado:
         * busca o setor onde a pessoa do usuário está alocada (id_setor), como no SolicitarView.
         */
        async atualizarSetorDestinatarioPorResponsavel() {
            if (!this.protocolo.responsavel_id) {
                this.protocolo.setorDestinatario_id = null;
                return;
            }
            try {
                const { data: pessoa } = await api.get("pessoa/usuario/buscar", {
                    params: { usuarioId: this.protocolo.responsavel_id },
                });
                this.protocolo.setorDestinatario_id = pessoa?.id_setor ?? null;
            } catch (e) {
                if (process.env.NODE_ENV !== "production") console.error(e);
                this.protocolo.setorDestinatario_id = null;
            }
        },

        async criarProtocolo() {
            this.loading = true;
            try {
                const payload = { ...this.protocolo, status: "Pendente" };
                const resultado = await serviceProtocolo.gravarProtocolo(payload);
                this.$router.push({ name: "visualizacaoProtocolo", params: { idProtocolo: resultado.id } });
            } catch (error) {
                this.handleApiError(error);
            } finally {
                this.loading = false;
            }
        },

        async carregarGerentesSetoresETipos() {
            try {
                const { usuarios, setores } = await consultarSetores();
                this.gerente = usuarios;
                this.setores = setores;
                this.tipos = await serviceProtocolo.listarTipos();
                await this.atualizarSetorDestinatarioPorResponsavel();
            } catch (error) {
                this.handleApiError(error);
            }
        },
    },
};
</script>
<style scoped></style>